import React from 'react'
import { Box, makeStyles, Typography } from '@material-ui/core'
import { Thermometer, Zap } from 'react-feather'
import { useTranslation } from 'react-i18next'
import { useReactiveVar } from '@apollo/client'
import { SystemContainerList } from '../system-container/SystemContainerList'
import { LocalGridFragment, LocalGridType } from '../../generated/graphql'
import { activeVersionVar } from '../../apollo/reactive-vars'
import { localGridTypeToProviderTypeMap } from '../../local-grid/local-grid-util'

const useStyles = makeStyles((theme) => ({
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 50,
    height: 50,
    borderRadius: 25,
    background: theme.palette.common.white,
  },
  buildingCount: {
    color: theme.palette.grey[500],
  },
}))

type Props = {
  localGrids: LocalGridFragment[]
  onLocalGridClick: (localGrid: LocalGridFragment) => void
}

export function LocalGridList({
  localGrids,
  onLocalGridClick,
}: Props): React.ReactElement {
  const classes = useStyles()
  const { t } = useTranslation()
  const activeVersion = useReactiveVar(activeVersionVar)

  const allBuildings = activeVersion?.buildings ?? []

  const getConnectedBuildingCount = (localGrid: LocalGridFragment) =>
    allBuildings.filter((building) =>
      building.providers.some(
        (provider) =>
          provider.type === localGridTypeToProviderTypeMap[localGrid.type],
      ),
    ).length

  return (
    <SystemContainerList
      items={localGrids}
      idGetter={(localGrid) => localGrid.id}
      renderItem={(localGrid) => (
        <Box className={classes.item}>
          <Box className={classes.iconContainer}>
            {localGrid.type === LocalGridType.Water ? <Thermometer /> : <Zap />}
          </Box>
          <Box mt={3}>
            <Typography variant="h6">{localGrid.type}</Typography>
            <Typography className={classes.buildingCount}>
              {t('project.buildingsConnected', {
                count: getConnectedBuildingCount(localGrid),
              })}
            </Typography>
          </Box>
        </Box>
      )}
      onItemClick={onLocalGridClick}
    />
  )
}
